// removed by extract-text-webpack-plugin
module.exports = {"header":"_1RVYiRvujos8-2IwnmO-Lh","header-right":"_1PYsqcb1W1PeNhzd0Pa7Cj","copy":"_26i6w7pZgyDgnTNBh6jNBV","content":"_42i-e87N1P6plcPOTWvOP","product-item":"UwHQ1zOc10c1k60aEL_Sv","preview-button-container":"_1s6VyPtQO7Q0YJptb2E-Dg","title":"_3tUf4MZ3IUJ0vdKzB2-Lg8","sale":"_1jb5SrX-L3PHzdz_0CL3Vb","preview-button":"_2-UAZ0M-lnXiQpYpYWnYEN","preview-container":"_2c8bgB5XRqaRj2JR9bRCop","preview-content":"_2lQw88jk-7JP6cAY6l7Ygv"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Products/products.module.styl
// module id = 659
// module chunks = 259173521737895